import mixitup from 'mixitup';
import mixitupMultifilter from './multifilter.js';

mixitup.use(mixitupMultifilter);

const mixitupContainer = document.querySelector('.team-container');

if (mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: ('all')
        },
        selectors: {
            target: '.team-member-teaser'
        },
        animation: {
            easing: 'ease-in-out'
        },
        multifilter: {
            enable: true
        }
    });
}
